// extracted by mini-css-extract-plugin
module.exports = {"main":"Article_main__BmLm8","main-heading":"Article_main-heading__3HgJw","heading-container":"Article_heading-container__OEIoA","body-container":"Article_body-container__3qRF3"};